import { createContext, useContext, type PropsWithChildren, type ReactElement } from 'react';
import type { ICorporateBondScreenerTrancheCollectionResponse } from '@/creditflowresearch/domain/vo/Bondscreener/ICorporateBondScreenerTranche';
import type { TFilterPayload } from '@/creditflowresearch/domain/vo/Bondscreener';
import useCorporateBondScreener from './useCorporateBondScreener';

type CorporateBondScreenerContextType = ReturnType<typeof useCorporateBondScreener>;

export const CorporateBondScreenerContext = createContext<CorporateBondScreenerContextType | null>(null);

export const useCorporateBondScreenerContext = (): CorporateBondScreenerContextType => {
  const context = useContext(CorporateBondScreenerContext);

  if (!context) {
    throw new Error('useCorporateBondScreenerContext must be used within CorporateBondScreenerContextProvider');
  }

  return context;
};

interface ICorporateBondScreenerContextProviderProps extends PropsWithChildren {
  initialTranches?: ICorporateBondScreenerTrancheCollectionResponse,
  columns?: readonly string[],
  initialFilters: TFilterPayload,
}

export const CorporateBondScreenerContextProvider = ({
  children,
  initialTranches,
  columns,
  initialFilters,
}: ICorporateBondScreenerContextProviderProps): ReactElement => (
  <CorporateBondScreenerContext.Provider
    value={ useCorporateBondScreener(initialFilters, initialTranches, columns) }
  >
    { children }
  </CorporateBondScreenerContext.Provider>
);
